import Vue from "vue";
import VueRouter from "vue-router";
import { decryptText } from "@/utils/crypto";
import { formatDateISO } from "@/utils/date";

Vue.use(VueRouter);

// NOTE: the "visits" and "login" records intentionally share the "/" path, and the
// "salesmen" path is "/ " (with a trailing space). Navigation always happens by route
// name, so these quirks are part of the current behaviour and are kept as they are.
const routes = [
  {
    path: "/",
    name: "visits",
    component: () => import("@/views/visits/Visits.vue"),
    meta: {
      title: "زيارات الصيانة",
    },
  },
  {
    path: "/ ",
    name: "salesmen",
    component: () => import("@/views/visits/Salesmen.vue"),
    meta: {
      title: "زيارات المبيعات",
    },
  },
  {
    path: "/attachment",
    name: "attachment",
    component: () => import("@/views/visits/attachment.vue"),
    meta: {
      title: "المرفقات",
    },
  },
  {
    name: "login",
    path: "/",
    component: () => import("@/views/auth/Login.vue"),
    meta: {
      title: "تسجيل الدخول",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

/**
 * The login screen stores today's date, encrypted, under "accessTocken" (sic: the
 * misspelled key is shared with Login.vue). The session is valid for the day it was created.
 */
const isSessionValid = () => {
  const token = localStorage.getItem("accessTocken");
  return token != null && decryptText(token) == formatDateISO();
};

router.beforeEach((to, from, next) => {
  if (to.name !== "login" && !isSessionValid()) {
    return next({ name: "login" });
  }
  return next();
});

export default router;
